<div class="col-3 px-0 d-flex flex-column overflow-hidden resizable-column">
  <div class="input-group mb-3 pe-2">
    <span class="input-group-text">
      <span class="fa-search"></span>
    </span>
    <textarea #oguSearchTextarea
              type="text"
              (input)="applyORGsAndOGUsSearch()"
              (keydown.enter)="$event.preventDefault();applyORGsAndOGUsSearch()"
              class="form-control search-textarea df-input-withicon"
              [(ngModel)]="orgOguSearch"
              placeholder="Search for ORGs & OGUs"
              aria-label="Search for ORGs & OGUs"
              id="deployment-search-orgs-ogus"
              [disabled]="!canDeployOrgOguLevels"
    ></textarea>
    <button class="input-group-text fa-times"
      (click)="orgOguSearch = ''; applyORGsAndOGUsSearch()"
      [class.df-is-empty]="orgOguSearch === ''">
      <span class="visually-hidden">Clear text</span>
    </button>
  </div>
  <div class="text-truncate border flex-grow-1 fixed-height no-right-border">
    <p class="h5 p-5 mb-0 text-wrap text-uppercase text-gray-600">Organization & Organization Units</p>
    <ng-content></ng-content>
  </div>
</div>
<div class="d-flex flex-column flex-grow-1 resizable-column">
  <div class="input-group mb-3 ps-2">
    <span class="input-group-text">
      <span class="fa-filter"></span>
    </span>
    <textarea #officeSearchTextarea
              type="text"
              (input)="applyOfficeSearch()"
              (keydown.enter)="$event.preventDefault()"
              (keydown.space)="$event.preventDefault()"
              class="form-control search-textarea df-input-withicon"
              [(ngModel)]="officeSearch"
              placeholder="Search for offices separated by commas"
              aria-label="Search for offices separated by commas"
              id="deployment-search-offices"
    ></textarea>
    <button class="input-group-text fa-times"
      (click)="officeSearch = ''; applyOfficeSearch()"
      [class.df-is-empty]="officeSearch === ''">
      <span class="visually-hidden">Clear text</span>
    </button>
  </div>
  <div class="d-flex flex-column flex-grow-1 px-5 border">
      <div class="d-flex row">
          <p class="h5 p-5 mb-0 text-uppercase text-gray-600 col">Offices {{ selectedActor ? 'in ' : ''}}
              {{ selectedActor ? (selectedActor.actorName |
              removeParentActor: selectedActorParentOrg?.actorName) : ''
              }} ({{ officesInSelectedEntity }})</p>
          <ng-content select="[filterOfficeToggle]"></ng-content>
      </div>
    <ng-content select="[offices]"></ng-content>
  </div>
</div>
